// src/pwa/registerServiceWorker.js
import { registerSW } from "virtual:pwa-register";
import { toast } from "sonner";

const UPDATE_CHECK_INTERVAL_MS = 60 * 60 * 1000; // 1 hour

export function registerServiceWorker() {
  if (!("serviceWorker" in navigator)) return;

  const updateSW = registerSW({
    immediate: true,

    // A new version is installed and waiting — let the user reload when convenient
    // (no forced reload, so in-progress work like board pack exports isn't lost)
    onNeedRefresh() {
      toast("A new version of Crystal Ball is available.", {
        id: "pwa-update",
        duration: Infinity,
        action: {
          label: "Reload",
          onClick: () => updateSW(true),
        },
      });
    },

    // Long-lived tabs / installed app windows: keep checking for new deployments
    onRegisteredSW(swUrl, registration) {
      if (!registration) return;

      const checkForUpdate = async () => {
        if (registration.installing || !navigator.onLine) return;
        try {
          // Bypass the HTTP cache so a stale sw.js is never served
          const resp = await fetch(swUrl, {
            cache: "no-store",
            headers: { cache: "no-store", "cache-control": "no-cache" },
          });
          if (resp?.status === 200) await registration.update();
        } catch {
          // offline / network error — try again on the next tick
        }
      };

      setInterval(checkForUpdate, UPDATE_CHECK_INTERVAL_MS);
      document.addEventListener("visibilitychange", () => {
        if (document.visibilityState === "visible") checkForUpdate();
      });
    },
  });
}
